import React, { useContext } from "react";
import styled from "styled-components";
import analytics from "services/analytics";
import { EventContext } from "Components";

import testDriveBanner from "Images/test-drive.jpg";
import artistImage from "Images/artist-circle.png";

export const VideoMeta = () => {
  const { event } = useContext(EventContext);

  const onClickHandler = () => {
    analytics.fireEvent({
      category: "External Link",
      action: "Banner Ad Under Video",
      label: window.location.host,
    });
  };

  return (
    <VideoMetaWrapper>
      <VideoMetaContainer>
        <a
          href="https://www.buyfordnow.com/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClickHandler}
        >
          <VideoBannerAd src={testDriveBanner} />
        </a>
        <ArtistMeta>
          <Thumbnail src={artistImage} />
          <MetaData>
            <p>Ford Truck Month Concert Series</p>
            <p>{event.artist}</p>
          </MetaData>
        </ArtistMeta>
      </VideoMetaContainer>
    </VideoMetaWrapper>
  );
};

const VideoMetaWrapper = styled.div`
  background: #102b4e;
  display: flex;
  flex: 1;
`;

const VideoMetaContainer = styled.div`
  width: 100%;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 25px;
    max-width: 900px;
  }
`;

const VideoBannerAd = styled.img`
  width: 100%;
  display: block;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    margin-bottom: 25px;
  }
`;

const ArtistMeta = styled.div`
  display: none;
  align-items: center;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    display: flex;
  }
`;

const Thumbnail = styled.img`
  width: 25%;
  max-width: 60px;
  margin-right: 15px;
`;

const MetaData = styled.div`
  display: flex;
  color: #ffffff;
  flex-direction: column;
  p {
    margin: 0;
  }
  p:first-of-type {
    text-transform: uppercase;
    margin-bottom: 5px;
  }
`;
